"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckboxLabel = exports.StyledCheckboxDisplayInput = exports.StyledCheckboxHiddenInput = exports.StyledCheckboxLabelText = exports.StyledError = exports.StyledCheckboxContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.StyledCheckboxContainer = styled_components_1.default.div `
  font-family: ${({ theme }) => theme.typography.desktop.text.small_default['font-family'].value};
  display: flex;
  flex-direction: column;
`;
exports.StyledError = styled_components_1.default.label `
  color: ${({ theme }) => theme.colors.colours.system.fail.value};
  font-size: ${({ theme }) => theme.typography.desktop.text.small_default['font-size'].value};
  font-weight: bold;
  padding-top: ${({ theme }) => theme.sizes['3xs'].value};
`;
exports.StyledCheckboxLabelText = styled_components_1.default.span `
  color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
  margin-left: ${({ theme }) => theme.sizes['2xs'].value};
  font-size: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['font-size'].value};
  line-height: ${({ theme }) => theme.typography.desktop.text['medium-small_default']['line-height'].value};
`;
exports.StyledCheckboxHiddenInput = styled_components_1.default.input.attrs({
    type: 'checkbox'
}) `
  display: none;
`;
exports.StyledCheckboxDisplayInput = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
      border: ${theme.borders['border-1px--solid']['border-width'].value}
        ${theme.borders['border-1px--solid']['border-style'].value}
        ${theme.colors.colours.default['digital-black'].value};
    `}
  height: ${({ theme }) => theme.sizes.s.value};
  width: ${({ theme }) => theme.sizes.s.value};
  transition: background-color 0.25s ease-in-out;
  border-radius: 3px;
  position: relative;

  &:before {
    content: '';
    opacity: 0;
  }
  ${({ checked, indeterminate }) => !indeterminate &&
    checked === true &&
    (0, styled_components_1.css) `
      background-color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
      &:before {
        height: 10px;
        width: 6px;
        position: absolute;
        top: calc(50% - 1px);
        left: 50%;
        border-right: 2px solid;
        border-bottom: 2px solid;
        border-bottom-right-radius: 2px;
        border-color: ${({ theme }) => theme.colors.colours.default.white.value};
        transition: 0.25s ease-in-out;
        transition-property: opacity, border-color;
        transform: translate(-50%, -50%) rotate(45deg);
        opacity: 1;
      }
    `}
  ${({ indeterminate }) => indeterminate &&
    (0, styled_components_1.css) `
      background-color: unset;
      &:before {
        width: 10px;
        position: absolute;
        top: 50%;
        left: 50%;
        border-bottom: 2px solid;
        border-color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
        transition: 0.25s ease-in-out;
        transition-property: opacity, border-color;
        transform: translate(-50%, -50%);
        opacity: 1;
      }
    `}
`;
exports.StyledCheckboxLabel = styled_components_1.default.label `
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  ${({ required }) => required &&
    (0, styled_components_1.css) `
      &::after {
        content: ' *';
        color: ${({ theme }) => theme.colors.colours.system.fail.value};
      }
    `}
  &:hover {
    ${exports.StyledCheckboxHiddenInput}:not(:checked) + ${exports.StyledCheckboxDisplayInput} {
      &:before {
        height: 10px;
        width: 6px;
        position: absolute;
        top: calc(50% - 1px);
        left: 50%;
        border-right: 2px solid;
        border-bottom: 2px solid;
        border-bottom-right-radius: 2px;
        transition: 0.25s ease-in-out;
        transition-property: opacity, border-color;
        transform: translate(-50%, -50%) rotate(45deg);
        border-color: ${({ theme }) => theme.colors.colours.default['digital-black'].value};
        opacity: 0.2;
      }
    }
  }
`;
//# sourceMappingURL=Checkbox.styled.js.map